import React from 'react';

export const NodeEditContext = React.createContext({});
